import React from 'react';

interface IconProps {
  size?: number;
  color?: string;
}

export const ProductBlogIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 7H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M7 11H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M7 15H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const CompanyBlogIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 18H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M9.5 18V9.5H14.5V18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.2 12H11.21M12.8 12H12.81M11.2 14.5H11.21M12.8 14.5H12.81" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const PersonalBlogIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2"/>
    <path d="M7 18C7 15.2386 9.23858 13 12 13C14.7614 13 17 15.2386 17 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const TechIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="5" y="5" width="14" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
    <rect x="9.5" y="9.5" width="5" height="5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M9 2V5M15 2V5M9 19V22M15 19V22M2 9H5M2 15H5M19 9H22M19 15H22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const AIIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M10 3L11.9 8.1L17 10L11.9 11.9L10 17L8.1 11.9L3 10L8.1 8.1L10 3Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M18 14L19 16.5L21.5 17.5L19 18.5L18 21L17 18.5L14.5 17.5L17 16.5L18 14Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

export const GadgetsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="7" y="6" width="10" height="12" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M9 6V2.5H15V6M9 18V21.5H15V18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 10V12.5H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const StartupIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M4.5 16.5C3 17.76 2.5 21.5 2.5 21.5C2.5 21.5 6.24 21 7.5 19.5C8.21 18.66 8.2 17.37 7.41 16.59C6.62 15.8 5.34 15.79 4.5 16.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 15L9 12C9.53 10.62 10.2 9.3 11 8.05C12.17 6.19 13.79 4.65 15.71 3.59C17.64 2.54 19.8 1.99 22 2C22 4.72 21.22 9.5 16 13C14.74 13.8 13.4 14.47 12 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 12H4C4 12 4.55 8.97 6 8C7.62 6.92 11 8 11 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 15V20C12 20 15.03 19.45 16 18C17.08 16.38 16 13 16 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const TechAudioIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M3 10V14C3 14.5523 3.44772 15 4 15H6L10 19V5L6 9H4C3.44772 9 3 9.44772 3 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 9C14.9 9.9 15.5 11.1 15.5 12.5C15.5 13.9 14.9 15.1 14 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M17 6C18.8 7.8 20 10.3 20 13C20 15.7 18.8 18.2 17 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const TechVideoIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="2" y="5" width="15" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M17 10L22 7V17L17 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const TechMobileIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="5" y="2" width="14" height="20" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M10 18H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M5 6H19" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
);

export const VintageComputerIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="3" y="3" width="18" height="12" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M7 7H11V11H7V7Z" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M13 7H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M13 10H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8 18H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M6 15H18V18H6V15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const TinkeringIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M14.7 6.3C14.3 5.9 14.1 5.3 14.1 4.7C14.1 3.2 15.3 2 16.8 2C17 2 17.2 2 17.4 2.1L15.5 4L16 6L18 6.5L19.9 4.6C19.9 4.8 20 5 20 5.2C20 6.7 18.8 7.9 17.3 7.9C16.7 7.9 16.1 7.7 15.7 7.3L7.7 15.3C8.1 15.7 8.3 16.3 8.3 16.9C8.3 18.4 7.1 19.6 5.6 19.6C5.4 19.6 5.2 19.6 5 19.5L6.9 17.6L6.4 15.6L4.4 15.1L2.5 17C2.5 16.8 2.4 16.6 2.4 16.4C2.4 14.9 3.6 13.7 5.1 13.7C5.7 13.7 6.3 13.9 6.7 14.3L14.7 6.3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const MusicIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M9 18V5L21 3V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="6" cy="18" r="3" stroke="currentColor" strokeWidth="2"/>
    <circle cx="18" cy="16" r="3" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

export const RockMusicIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="8.5" cy="15.5" r="5" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 12L20 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M19 3L21 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="8.5" cy="15.5" r="1" fill="currentColor"/>
  </svg>
);

export const InstrumentsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="3" y="6" width="18" height="12" rx="1.5" stroke="currentColor" strokeWidth="2"/>
    <path d="M7.5 12V18M12 12V18M16.5 12V18" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M7.5 6V12M12 6V12M16.5 6V12" stroke="currentColor" strokeWidth="3"/>
  </svg>
);

export const JazzIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M14 8.5C17 8.5 19.5 7 21.5 5.5V18.5C19.5 17 17 15.5 14 15.5V8.5Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M2.5 10H14M2.5 14H14M2.5 10V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M6.5 10V14M9.5 10V14M12.5 10V14" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
);

export const RnBIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 2C10.3431 2 9 3.34315 9 5V12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12V5C15 3.34315 13.6569 2 12 2Z" stroke="currentColor" strokeWidth="2"/>
    <path d="M19 10V12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 19V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const HipHopIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="2.5" y="8" width="19" height="12" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M8 8V5C8 4.44772 8.44772 4 9 4H15C15.5523 4 16 4.44772 16 5V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="7.5" cy="14" r="2.5" stroke="currentColor" strokeWidth="2"/>
    <circle cx="16.5" cy="14" r="2.5" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

export const MetalIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 2C7.58172 2 4 5.58172 4 10C4 12.4 5.06 14.55 6.75 16V19C6.75 20.1046 7.64543 21 8.75 21H15.25C16.3546 21 17.25 20.1046 17.25 19V16C18.94 14.55 20 12.4 20 10C20 5.58172 16.4183 2 12 2Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <circle cx="9" cy="11" r="1.5" fill="currentColor"/>
    <circle cx="15" cy="11" r="1.5" fill="currentColor"/>
    <path d="M10.5 21V18M13.5 21V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const IndieIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="2.5" y="5.5" width="19" height="13" rx="2" stroke="currentColor" strokeWidth="2"/>
    <circle cx="8.5" cy="11" r="1.75" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="15.5" cy="11" r="1.75" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M10.25 11H13.75" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M6 18.5L7.5 15H16.5L18 18.5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

export const ClassicalMusicIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M7 2C7 2 9 4 9 7V11.5C9 13.433 10.343 15 12 15C13.657 15 15 13.433 15 11.5V7C15 4 17 2 17 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M10.75 5.5V13.5M13.25 5.5V13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 15V20.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M8.5 20.5H15.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const PopMusicIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M3 14C3 9.02944 7.02944 5 12 5C16.9706 5 21 9.02944 21 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M3 14V17C3 18.1046 3.89543 19 5 19H6C6.55228 19 7 18.5523 7 18V15C7 14.4477 6.55228 14 6 14H3Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M21 14V17C21 18.1046 20.1046 19 19 19H18C17.4477 19 17 18.5523 17 18V15C17 14.4477 17.4477 14 18 14H21Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
  </svg>
);

export const ElectronicMusicIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
    <circle cx="12" cy="12" r="1" fill="currentColor"/>
    <path d="M12 3V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M21 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M6 12H3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 18V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const SportsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M8 22H16M12 18V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 7H18V11C18 14.3137 15.3137 17 12 17C8.68629 17 6 14.3137 6 11V7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 9H4V11C4 12.1046 4.89543 13 6 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 9H20V11C20 12.1046 19.1046 13 18 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const FootballIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M4.2 19.8C2.7 18.3 3.5 12.5 7.5 8.5C11.5 4.5 17.3 3.7 18.8 5.2C20.3 6.7 19.5 12.5 15.5 16.5C11.5 20.5 5.7 21.3 4.2 19.8Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M9.5 14.5L14.5 9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M10.25 12.25L11.75 13.75M12.25 10.25L13.75 11.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const BasketballIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 3V21M3 12H21" stroke="currentColor" strokeWidth="2"/>
    <path d="M5.65 5.65C8.5 8 8.5 16 5.65 18.35M18.35 5.65C15.5 8 15.5 16 18.35 18.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const BaseballIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
    <path d="M7 7C7 7 8 9 8 12C8 15 7 17 7 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M17 7C17 7 16 9 16 12C16 15 17 17 17 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const SoccerIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 3L14.5 8.5L20.5 8.5L15.5 12.5L17.5 18L12 14.5L6.5 18L8.5 12.5L3.5 8.5L9.5 8.5L12 3Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <circle cx="12" cy="12" r="3.5" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

export const FoodIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M4 2V9C4 10.1046 4.89543 11 6 11H10C11.1046 11 12 10.1046 12 9V2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 2V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M21 15V2C18.2386 2 16 4.23858 16 7V13C16 14.1046 16.8954 15 18 15H21ZM21 15V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const BusinessIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="3" y="7" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M8 7V5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V7" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 12V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M3 12H21" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

export const StorefrontIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M3.5 9L5 4H19L20.5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.5 9H21.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M4.5 9V20M19.5 9V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M2.5 20H21.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M9.5 20V14.5H14.5V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const FinanceIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 5.5V18.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M14.8 8.5C14.3 7.6 13.2 7 12 7C10.3 7 9 8 9 9.5C9 11 10.3 11.6 12 12C13.7 12.4 15 13 15 14.5C15 16 13.7 17 12 17C10.8 17 9.7 16.4 9.2 15.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const InvestingIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M8 4V7M8 14V18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <rect x="6" y="7" width="4" height="7" rx="0.5" stroke="currentColor" strokeWidth="2"/>
    <path d="M16 6V10M16 16V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <rect x="14" y="10" width="4" height="6" rx="0.5" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

export const IndustryNewsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M3 21V10L8 13.5V10L13 13.5V10L18 13.5V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 8V4C18 3.44772 18.4477 3 19 3H20C20.5523 3 21 3.44772 21 4V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 21H22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M6.5 17.5H7.5M11.5 17.5H12.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const NewsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M7 8H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M7 12H11" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M7 16H11" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <rect x="14" y="12" width="3" height="4" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

export const GamingIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M6 7H18C19.6569 7 21 8.34315 21 10V14C21 15.6569 19.6569 17 18 17H6C4.34315 17 3 15.6569 3 14V10C3 8.34315 4.34315 7 6 7Z" stroke="currentColor" strokeWidth="2"/>
    <path d="M8 10V14M6 12H10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="17.5" cy="10.5" r="1" fill="currentColor"/>
    <circle cx="15" cy="13.5" r="1" fill="currentColor"/>
  </svg>
);

export const ArtIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6C15.866 6 19 9.13401 19 13C19 14.6569 17.6569 16 16 16H14C12.8954 16 12 16.8954 12 18C12 19.1046 12.8954 20 14 20H16C19.866 20 23 16.866 23 13C23 7.47715 18.5228 2 12 2Z" stroke="currentColor" strokeWidth="2"/>
    <circle cx="8" cy="9" r="1.5" fill="currentColor"/>
    <circle cx="12" cy="9" r="1.5" fill="currentColor"/>
    <circle cx="8" cy="13" r="1.5" fill="currentColor"/>
    <circle cx="15" cy="12" r="1.5" fill="currentColor"/>
  </svg>
);

export const ComedyIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
    <path d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="9" cy="9" r="1" fill="currentColor"/>
    <circle cx="15" cy="9" r="1" fill="currentColor"/>
  </svg>
);

export const ComicsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M21 11C21 15.418 16.97 19 12 19C10.55 19 9.18 18.71 7.97 18.2L3 20L4.3 15.69C3.48 14.39 3 12.76 3 11C3 6.582 7.03 3 12 3C16.97 3 21 6.582 21 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="8" cy="11" r="1" fill="currentColor"/>
    <circle cx="12" cy="11" r="1" fill="currentColor"/>
    <circle cx="16" cy="11" r="1" fill="currentColor"/>
  </svg>
);

export const SoftwareDevIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M8 6L4 12L8 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 6L20 12L16 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13 4L11 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const WebDevIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="2.5" y="4" width="19" height="16" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M2.5 9H21.5" stroke="currentColor" strokeWidth="2"/>
    <path d="M9.5 12.5L7 15L9.5 17.5M14.5 12.5L17 15L14.5 17.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const JavaScriptIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M8 3H7C5.89543 3 5 3.89543 5 5V10C5 11.1046 4.10457 12 3 12C4.10457 12 5 12.8954 5 14V19C5 20.1046 5.89543 21 7 21H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 3H17C18.1046 3 19 3.89543 19 5V10C19 11.1046 19.8954 12 21 12C19.8954 12 19 12.8954 19 14V19C19 20.1046 18.1046 21 17 21H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const JavaIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M17 9H18C20.2091 9 22 10.7909 22 13C22 15.2091 20.2091 17 18 17H17" stroke="currentColor" strokeWidth="2"/>
    <path d="M3 9H17V17C17 19.2091 15.2091 21 13 21H7C4.79086 21 3 19.2091 3 17V9Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M6.5 2.5V5.5M10 2.5V5.5M13.5 2.5V5.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const PythonIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M16 6.5C16 4.567 14.2091 3 12 3C9.79086 3 8 4.567 8 6.5C8 8.433 9.79086 10 12 10C14.2091 10 16 11.567 16 13.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M8 17.5C8 19.433 9.79086 21 12 21C14.2091 21 16 19.433 16 17.5C16 15.567 14.2091 14 12 14C9.79086 14 8 12.433 8 10.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="10.5" cy="5.75" r="1" fill="currentColor"/>
    <circle cx="13.5" cy="18.25" r="1" fill="currentColor"/>
  </svg>
);

export const DevOpsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 12C10 9.33 8 8 6 8C3.79086 8 2 9.79086 2 12C2 14.2091 3.79086 16 6 16C8 16 10 14.67 12 12ZM12 12C14 14.67 16 16 18 16C20.2091 16 22 14.2091 22 12C22 9.79086 20.2091 8 18 8C16 8 14 9.33 12 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const PCGamingIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="6" y="2.5" width="12" height="19" rx="6" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 6.5V10.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const MobileGamingIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="2" y="6" width="20" height="12" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M7.5 10V14M5.5 12H9.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <circle cx="16" cy="11" r="1" fill="currentColor"/>
    <circle cx="18" cy="13" r="1" fill="currentColor"/>
  </svg>
);

export const BoardGamesIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="4" y="4" width="16" height="16" rx="3" stroke="currentColor" strokeWidth="2"/>
    <circle cx="9" cy="9" r="1.2" fill="currentColor"/>
    <circle cx="15" cy="9" r="1.2" fill="currentColor"/>
    <circle cx="12" cy="12" r="1.2" fill="currentColor"/>
    <circle cx="9" cy="15" r="1.2" fill="currentColor"/>
    <circle cx="15" cy="15" r="1.2" fill="currentColor"/>
  </svg>
);

export const RetroGamingIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="3" y="6" width="18" height="12" rx="3" stroke="currentColor" strokeWidth="2"/>
    <path d="M7 10V14M5 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="16" cy="11" r="1" fill="currentColor"/>
    <circle cx="18" cy="13" r="1" fill="currentColor"/>
  </svg>
);

export const MicrosoftIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="3" y="3" width="8" height="8" stroke="currentColor" strokeWidth="2"/>
    <rect x="13" y="3" width="8" height="8" stroke="currentColor" strokeWidth="2"/>
    <rect x="3" y="13" width="8" height="8" stroke="currentColor" strokeWidth="2"/>
    <rect x="13" y="13" width="8" height="8" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

export const LinuxIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 2C9.5 2 8 4.5 8 7V11C8 12 7 13 6 14C5 15 4 16 4 17.5C4 19 5 20 7 20H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 2C14.5 2 16 4.5 16 7V11C16 12 17 13 18 14C19 15 20 16 20 17.5C20 19 19 20 17 20H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 20V22H15V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="10" cy="7" r="1" fill="currentColor"/>
    <circle cx="14" cy="7" r="1" fill="currentColor"/>
    <path d="M10 10C10 10 11 11 12 11C13 11 14 10 14 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const HealthIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.04L12 21.35Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const HeartPulseIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.04L12 21.35Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 11.5H8.5L10.5 8.5L13 14.5L14.5 11.5H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const FitnessIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M6.5 6.5V17.5M17.5 6.5V17.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M6.5 12H17.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M3 8V16M21 8V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M3 12H6.5M17.5 12H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const ITIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M8 21H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 17V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M7 7H17M7 11H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const SecurityIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 2L3 7V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="9" y="10" width="6" height="5" rx="1" stroke="currentColor" strokeWidth="2"/>
    <path d="M10 10V8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const AutomotiveIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M19 17H21C21.5523 17 22 16.5523 22 16V13C22 12.0557 21.342 11.2398 20.4191 11.0414L16 10L13.5 7.5C13.1255 7.12525 12.6173 6.91467 12.0875 6.91467H5.23606C4.49856 6.91467 3.82312 7.33147 3.49321 7.99105L2.21115 10.5547C2.07229 10.8324 2 11.1387 2 11.4492V16C2 16.5523 2.44772 17 3 17H5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="7" cy="17" r="2" stroke="currentColor" strokeWidth="2"/>
    <circle cx="17" cy="17" r="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M9 17H15" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

export const AviationIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M21 16V14L13 9V3.5C13 2.67 12.33 2 11.5 2C10.67 2 10 2.67 10 3.5V9L2 14V16L10 13.5V19L8 20.5V22L11.5 21L15 22V20.5L13 19V13.5L21 16Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const TravelIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="4" y="7" width="16" height="13" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M9 7V5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7" stroke="currentColor" strokeWidth="2"/>
    <path d="M8.5 7V20M15.5 7V20" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
);

export const CruisingIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M9 7V4H15V7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 11V7H19V11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 11H21L19.5 15.5H4.5L3 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 19C4 20 5 20 6 19C7 18 8 18 9 19C10 20 11 20 12 19C13 18 14 18 15 19C16 20 17 20 18 19C19 18 20 18 21 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const DestinationsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 21C12 21 19 14.5 19 9.5C19 5.36 15.87 2 12 2C8.13 2 5 5.36 5 9.5C5 14.5 12 21 12 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="9.5" r="2.5" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

export const TipsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 2C8.13 2 5 5.13 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.13 15.87 2 12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.5 21H14.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const ThemeParksIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="12" cy="10" r="7" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 3V17M5 10H19M7.05 5.05L16.95 14.95M16.95 5.05L7.05 14.95" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="12" cy="10" r="1.5" fill="currentColor"/>
    <path d="M8.5 21.5L12 17L15.5 21.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const SavingIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M19 5C17.5 5 16.2 6.4 16 7C12.5 5.5 5 6.7 5 12C5 13.8 5 15 7 16.5V20H11V18H14V20H18V16C19 15.5 19.7 15 20 14H22V10H20C20 9 19.5 8.5 19 8V5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 9V10C2 11.1 2.9 12 4 12H5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="16" cy="11" r="1" fill="currentColor"/>
  </svg>
);

export const DIYIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const PhotographyIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="2" y="6" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
    <circle cx="12" cy="13" r="3" stroke="currentColor" strokeWidth="2"/>
    <circle cx="18" cy="9" r="1" fill="currentColor"/>
  </svg>
);

export const MarketingIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M3 11L21 6V18L3 14V11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.6 16.8C11.1567 18.4547 9.45556 19.4367 7.8 18.9933C6.7212 18.7042 5.87846 17.8615 5.58934 16.7827L5.2 15.33" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const AdvertisingIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="4" y="3.5" width="16" height="10.5" rx="1" stroke="currentColor" strokeWidth="2"/>
    <path d="M7.5 7.5H16.5M7.5 10.5H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 14V16.5M12 16.5L8 21M12 16.5L16 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const SEOIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="10.5" cy="10.5" r="7.5" stroke="currentColor" strokeWidth="2"/>
    <path d="M16 16L21.5 21.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M7 12.5L9.5 10L11 11.5L14 8.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 8.5V11M14 8.5H11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const GrowthIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 21V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 13C8 13 5 10.5 4.5 6.5C8.5 7 11.5 9 12 13Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M12 10C12 6.5 14.5 4 18.5 3.5C18 7.5 15.5 10 12 10Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M6 21H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const EducationIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M2 10L12 5L22 10L12 15L2 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 12.5V17C6 17 8 19 12 19C16 19 18 17 18 17V12.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M22 10V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const FictionIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M4 19.5C4 18.1193 5.11929 17 6.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.5 2H20V22H6.5C5.11929 22 4 20.8807 4 19.5V4.5C4 3.11929 5.11929 2 6.5 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 5L13.4 8.6L17 10L13.4 11.4L12 15L10.6 11.4L7 10L10.6 8.6L12 5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

export const LiteratureIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M2 4.5C2 3.11929 3.11929 2 4.5 2H11V22H4.5C3.11929 22 2 20.8807 2 19.5V4.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M22 4.5C22 3.11929 20.8807 2 19.5 2H13V22H19.5C20.8807 22 22 20.8807 22 19.5V4.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 7H9M5 11H9M5 15H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M15 7H19M15 11H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const GovernmentIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 2L2 7V9H22V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 9V20H8V9M10 9V20H14V9M16 9V20H20V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 20H22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const PoliticsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M5 7C5 5.89543 5.89543 5 7 5H17C18.1046 5 19 5.89543 19 7V19H5V7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 11.5L11 13.5L15 9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 19H22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const HistoryIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M4 19.5C4 18.1193 5.11929 17 6.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.5 2H20V22H6.5C5.11929 22 4 20.8807 4 19.5V4.5C4 3.11929 5.11929 2 6.5 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 7H16M10 11H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const ParentingIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="9" cy="7" r="3" stroke="currentColor" strokeWidth="2"/>
    <circle cx="16" cy="10" r="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M5 21C5 18.2386 7.23858 16 10 16H12C13.6569 16 15 17.3431 15 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M15 21C15 19.3431 16.3431 18 18 18C19.6569 18 21 19.3431 21 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const EntertainmentIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
    <path d="M10 8L16 12L10 16V8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ReligionIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M4 19.5C4 18.1193 5.11929 17 6.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.5 2H20V22H6.5C5.11929 22 4 20.8807 4 19.5V4.5C4 3.11929 5.11929 2 6.5 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 6V14M8 10H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const ScienceIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M9 3H15M10 3V9L6 19C5.61 19.78 5.68 20.73 6.19 21.42C6.7 22.11 7.56 22.5 8.5 22.5H15.5C16.44 22.5 17.3 22.11 17.81 21.42C18.32 20.73 18.39 19.78 18 19L14 9V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 16H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const CultureIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
    <path d="M2 12H22M12 2C14.5 5 15.5 9 15.5 12C15.5 15 14.5 19 12 22M12 2C9.5 5 8.5 9 8.5 12C8.5 15 9.5 19 12 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const CrimeIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 2L3 7V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 8V12M12 16H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const FilmTVIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M7 3V7M12 3V7M17 3V7M7 17V21M12 17V21M17 17V21M2 7H22M2 17H22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const ReviewsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 3L14.7 8.6L20.8 9.5L16.4 13.8L17.4 19.9L12 17L6.6 19.9L7.6 13.8L3.2 9.5L9.3 8.6L12 3Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
  </svg>
);

export const ClapperboardIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M20.2 6L3 11L2.1 8.6C1.8 7.5 2.4 6.4 3.4 6.1L16.9 2.1C18 1.8 19.1 2.4 19.4 3.4L20.2 6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.2 5.3L9.3 9.2M12.4 3.4L15.5 7.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M3 11H21V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const SatireIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
    <circle cx="9" cy="9.5" r="1" fill="currentColor"/>
    <path d="M14 9.5H16.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M8.5 14.5C8.5 14.5 10 16.5 12.5 16.5C14.4 16.5 15.7 15.4 15.7 15.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const FashionIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M9 4C10.2 5.7 13.8 5.7 15 4C17 4.5 18.6 6 19 8.4C17.8 9.1 16 9.2 14.8 8.8C15 9.8 14.8 10.5 14.6 11.4C17 14.4 19 18 20.3 21C17.4 22.6 6.6 22.6 3.7 21C5 18 7 14.4 9.4 11.4C9.2 10.5 9 9.8 9.2 8.8C8 9.2 6.2 9.1 5 8.4C5.4 6 7 4.5 9 4Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M9.4 11.4H14.6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const EnvironmentIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 22C12 22 4 18 4 11C4 6 8 2 12 2C16 2 20 6 20 11C20 18 12 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 22V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 12C12 12 8 10 8 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 15C12 15 16 13 16 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const NatureIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 22V16M12 16C8 16 3 14 3 9C3 7 4 5 6 4C6 2.5 7.5 1 10 1C11.5 1 12.5 1.5 13 2.5C13.5 1.5 14.5 1 16 1C18.5 1 20 2.5 20 4C22 5 23 7 23 9C23 14 18 16 14 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const EconomicsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M3 3V18C3 19.66 4.34 21 6 21H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 14L11 10L15 14L21 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21 8V12M21 8H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const AdultIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
    <path d="M9 9H9.01M15 9H15.01M9 15H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 12V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const CountryMusicIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    {/* Hat brim */}
    <path d="M3 14C3 14 4 12 6 12H18C20 12 21 14 21 14C21 14 20 16 18 16H6C4 16 3 14 3 14Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Hat crown */}
    <path d="M7 12C7 12 7 8 8 6C9 4 10 3 12 3C14 3 15 4 16 6C17 8 17 12 17 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Crown crease/dent */}
    <path d="M12 3V7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    {/* Hat band */}
    <path d="M7 12H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const PiracyIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 2L3 7V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 12L11 15L16 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 10L12 4L20 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const CryptoIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
    <path d="M10 8H13C14.1 8 15 8.9 15 10C15 11.1 14.1 12 13 12H10V8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 12H13.5C14.6 12 15.5 12.9 15.5 14C15.5 15.1 14.6 16 13.5 16H10V12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 8V16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M11.5 7V8M11.5 16V17M13 7V8M13 16V17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const RoboticsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="5" y="9" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 9V5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="12" cy="3.5" r="1.5" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="9.5" cy="13" r="1" fill="currentColor"/>
    <circle cx="14.5" cy="13" r="1" fill="currentColor"/>
    <path d="M9.5 16H14.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M5 13H2.5M21.5 13H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const AstrologyIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="20" cy="5" r="1.5" fill="currentColor"/>
    <circle cx="17" cy="2" r="1" fill="currentColor"/>
    <circle cx="22" cy="8" r="1" fill="currentColor"/>
  </svg>
);

export const LawIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 3V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M5 21H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M5 7H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M5 7L2 13C2 14.66 3.34 16 5 16C6.66 16 8 14.66 8 13L5 7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19 7L16 13C16 14.66 17.34 16 19 16C20.66 16 22 14.66 22 13L19 7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const SpaceIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="2"/>
    <path d="M15.6 8.5C18.2 8.3 20.2 8.5 21 8.9C21.8 9.4 21.3 10.1 19.6 10.9C18 11.7 15.4 12.4 12.6 12.9C9.7 13.4 6.9 13.7 5 13.5C3.1 13.4 2.3 12.9 2.8 12.2C3.2 11.5 4.9 10.7 7.4 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const DefenseIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M12 2L3 7V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.5 11L12 8.5L15.5 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.5 15.5L12 13L15.5 15.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const HobbyIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <g transform="rotate(-12 12 12)">
      <path d="M12 2.5L18 8.5L12 17.5L6 8.5L12 2.5Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
      <path d="M12 2.5V17.5M6 8.5H18" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M12 17.5C11 19.2 13.3 20.2 12.4 21.4C11.9 22.1 10.7 22.3 9.8 21.8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </g>
  </svg>
);

export const SportsOtherIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="12" cy="15.5" r="5.5" stroke="currentColor" strokeWidth="2"/>
    <path d="M9 11L6 2.5H10L12 7.5L14 2.5H18L15 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 13.5L12.9 15.3L14.9 15.6L13.45 17L13.8 19L12 18.05L10.2 19L10.55 17L9.1 15.6L11.1 15.3L12 13.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

export const LocalNewsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M11 20H5C3.89543 20 3 19.1046 3 18V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M7 8H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M7 12H11" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M17.5 12C15.567 12 14 13.567 14 15.5C14 18 17.5 22 17.5 22C17.5 22 21 18 21 15.5C21 13.567 19.433 12 17.5 12Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <circle cx="17.5" cy="15.5" r="1" fill="currentColor"/>
  </svg>
);

export const InternationalNewsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
    <path d="M3 12H21" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 3C14.5 5.5 15.5 8.5 15.5 12C15.5 15.5 14.5 18.5 12 21C9.5 18.5 8.5 15.5 8.5 12C8.5 8.5 9.5 5.5 12 3Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
  </svg>
);

// Regional news: newspaper with the region abbreviation as headline.
const regionNewsIcon = (label: string, fontSize = 8): React.FC<IconProps> => ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M7 8H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <text x="12" y="17" textAnchor="middle" fontSize={fontSize} fontWeight="700" fill="currentColor" stroke="none" fontFamily="sans-serif">{label}</text>
  </svg>
);

export const NewsUsIcon = regionNewsIcon('US');
export const NewsUkIcon = regionNewsIcon('UK');
export const NewsAunzIcon = regionNewsIcon('ANZ', 7);
export const NewsCaIcon = regionNewsIcon('CA');

export const DrinksIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M4 4H20L12 12.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 12.5V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M8 21H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M15.5 2L10 8.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const ChatIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color }}>
    <path d="M16 9V5C16 3.89543 15.1046 3 14 3H5C3.89543 3 3 3.89543 3 5V15.5L6.5 13H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 11C9 9.89543 9.89543 9 11 9H19C20.1046 9 21 9.89543 21 11V21.5L17.5 19H11C9.89543 19 9 18.1046 9 17V11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Map category names to their icon components
export const categoryIconMap: Record<string, React.FC<IconProps>> = {
  'personal-blog': PersonalBlogIcon,
  'product-blog': ProductBlogIcon,
  'company-blog': CompanyBlogIcon,
  'art': ArtIcon,
  'business': BusinessIcon,
  'business/small': StorefrontIcon,
  'business/finance': FinanceIcon,
  'business/investing': InvestingIcon,
  'business/industry-news': IndustryNewsIcon,
  'economics': EconomicsIcon,
  'comedy': ComedyIcon,
  'comedy/satire': SatireIcon,
  'comics': ComicsIcon,
  'tech': TechIcon,
  'tech/ai': AIIcon,
  'tech/gadgets': GadgetsIcon,
  'tech/startups': StartupIcon,
  'tech/audio': TechAudioIcon,
  'tech/video': TechVideoIcon,
  'tech/mobile': TechMobileIcon,
  'tech/tinkering': TinkeringIcon,
  'tech/vintage': VintageComputerIcon,
  'tech/crypto': CryptoIcon,
  'tech/robotics': RoboticsIcon,
  'software-development': SoftwareDevIcon,
  'software-development/ai': AIIcon,
  'software-development/web': WebDevIcon,
  'software-development/javascript': JavaScriptIcon,
  'software-development/java': JavaIcon,
  'software-development/python': PythonIcon,
  'software-development/mobile': TechMobileIcon,
  'software-development/devops': DevOpsIcon,
  'software-development/linux': LinuxIcon,
  'software-development/microsoft': MicrosoftIcon,
  'gaming': GamingIcon,
  'gaming/pc': PCGamingIcon,
  'gaming/consoles': GamingIcon,
  'gaming/mobile': MobileGamingIcon,
  'gaming/board-games': BoardGamesIcon,
  'gaming/retro': RetroGamingIcon,
  'health': HeartPulseIcon,
  'fitness': FitnessIcon,
  'it': ITIcon,
  'it/security': SecurityIcon,
  'automotive': AutomotiveIcon,
  'aviation': AviationIcon,
  'travel': TravelIcon,
  'travel/cruising': CruisingIcon,
  'travel/destinations': DestinationsIcon,
  'travel/tips': TipsIcon,
  'travel/theme-parks': ThemeParksIcon,
  'travel/saving': SavingIcon,
  'diy': DIYIcon,
  'photography': PhotographyIcon,
  'photography/techniques': PhotographyIcon,
  'photography/viewing': PhotographyIcon,
  'marketing': MarketingIcon,
  'marketing/advertising': AdvertisingIcon,
  'marketing/seo': SEOIcon,
  'marketing/growth': GrowthIcon,
  'food': FoodIcon,
  'education': EducationIcon,
  'fiction': FictionIcon,
  'literature': LiteratureIcon,
  'government': GovernmentIcon,
  'law': LawIcon,
  'politics': PoliticsIcon,
  'lifenhealth': HealthIcon,
  'history': HistoryIcon,
  'parenting': ParentingIcon,
  'music': MusicIcon,
  'music/instruments': InstrumentsIcon,
  'music/pop': PopMusicIcon,
  'music/rock': RockMusicIcon,
  'music/classical': ClassicalMusicIcon,
  'music/country': CountryMusicIcon,
  'music/jazz': JazzIcon,
  'music/rnb': RnBIcon,
  'music/hip-hop': HipHopIcon,
  'music/electronic': ElectronicMusicIcon,
  'music/metal': MetalIcon,
  'music/indie': IndieIcon,
  'entertainment': EntertainmentIcon,
  'news': NewsIcon,
  'news/us': NewsUsIcon,
  'news/uk': NewsUkIcon,
  'news/aunz': NewsAunzIcon,
  'news/ca': NewsCaIcon,
  'news/international': InternationalNewsIcon,
  'news/local': LocalNewsIcon,
  'space': SpaceIcon,
  'defense': DefenseIcon,
  'hobby': HobbyIcon,
  'food/drinks': DrinksIcon,
  'chat': ChatIcon,
  'religion': ReligionIcon,
  'astrology': AstrologyIcon,
  'religion/spirituality': ReligionIcon,
  'religion/christian': ReligionIcon,
  'science': ScienceIcon,
  'culture': CultureIcon,
  'sports': SportsIcon,
  'sports/football': FootballIcon,
  'sports/basketball': BasketballIcon,
  'sports/baseball': BaseballIcon,
  'sports/soccer': SoccerIcon,
  'sports/other': SportsOtherIcon,
  'crime': CrimeIcon,
  'film+tv': FilmTVIcon,
  'film+tv/reviews': ReviewsIcon,
  'film+tv/news': ClapperboardIcon,
  'fashion': FashionIcon,
  'environment': EnvironmentIcon,
  'nature': NatureIcon,
  'adult': AdultIcon,
  'piracy+illegal': PiracyIcon,
};

// Map category names to their colors
export const categoryColorMap: Record<string, string> = {
  'personal-blog': '#8B7355',
  'product-blog': '#8B7355',
  'company-blog': '#6B7A8F',
  'art': '#9C27B0',
  'business': '#2E7D32',
  'business/small': '#388E3C',
  'business/finance': '#1B5E20',
  'business/investing': '#2E7D32',
  'business/industry-news': '#33691E',
  'economics': '#1976D2',
  'comedy': '#FF6F00',
  'comedy/satire': '#F57C00',
  'comics': '#E91E63',
  'tech': '#1976D2',
  'tech/ai': '#00ACC1',
  'tech/gadgets': '#2196F3',
  'tech/startups': '#FF7043',
  'tech/audio': '#5C6BC0',
  'tech/video': '#E53935',
  'tech/mobile': '#00897B',
  'tech/tinkering': '#8D6E63',
  'tech/vintage': '#6D4C41',
  'tech/crypto': '#F57C00',
  'tech/robotics': '#546E7A',
  'software-development': '#0288D1',
  'software-development/ai': '#00ACC1',
  'software-development/web': '#0097A7',
  'software-development/javascript': '#F9A825',
  'software-development/java': '#D84315',
  'software-development/python': '#1565C0',
  'software-development/mobile': '#00897B',
  'software-development/devops': '#5E35B1',
  'software-development/linux': '#E65100',
  'software-development/microsoft': '#0078D4',
  'gaming': '#7B1FA2',
  'gaming/pc': '#8E24AA',
  'gaming/consoles': '#9C27B0',
  'gaming/mobile': '#AB47BC',
  'gaming/board-games': '#BA68C8',
  'gaming/retro': '#6A1B9A',
  'health': '#D32F2F',
  'fitness': '#C62828',
  'it': '#1565C0',
  'it/security': '#37474F',
  'automotive': '#424242',
  'aviation': '#0277BD',
  'travel': '#00838F',
  'travel/cruising': '#0097A7',
  'travel/destinations': '#00ACC1',
  'travel/tips': '#00BCD4',
  'travel/theme-parks': '#26C6DA',
  'travel/saving': '#4DD0E1',
  'diy': '#6D4C41',
  'photography': '#5D4037',
  'photography/techniques': '#6D4C41',
  'photography/viewing': '#795548',
  'marketing': '#E65100',
  'marketing/advertising': '#EF6C00',
  'marketing/seo': '#F57C00',
  'marketing/growth': '#43A047',
  'food': '#F57F17',
  'education': '#1565C0',
  'fiction': '#6A1B9A',
  'literature': '#4E342E',
  'government': '#37474F',
  'law': '#4E342E',
  'politics': '#263238',
  'lifenhealth': '#D32F2F',
  'history': '#5D4037',
  'parenting': '#EC407A',
  'music': '#C2185B',
  'music/instruments': '#D81B60',
  'music/pop': '#E91E63',
  'music/rock': '#F44336',
  'music/classical': '#7B1FA2',
  'music/country': '#8D6E63',
  'music/jazz': '#5E35B1',
  'music/rnb': '#D81B60',
  'music/hip-hop': '#FF6F00',
  'music/electronic': '#00BCD4',
  'music/metal': '#424242',
  'music/indie': '#9C27B0',
  'entertainment': '#D32F2F',
  'news': '#424242',
  'news/us': '#3949AB',
  'news/uk': '#C62828',
  'news/aunz': '#00695C',
  'news/ca': '#D32F2F',
  'news/international': '#1565C0',
  'news/local': '#616161',
  'space': '#303F9F',
  'defense': '#455A64',
  'hobby': '#F4511E',
  'food/drinks': '#EF6C00',
  'chat': '#039BE5',
  'religion': '#5E35B1',
  'astrology': '#7B1FA2',
  'religion/spirituality': '#7B1FA2',
  'religion/christian': '#673AB7',
  'science': '#00897B',
  'culture': '#00ACC1',
  'sports': '#FF6F00',
  'sports/football': '#F57C00',
  'sports/basketball': '#EF6C00',
  'sports/baseball': '#E65100',
  'sports/soccer': '#388E3C',
  'sports/other': '#FB8C00',
  'crime': '#B71C1C',
  'film+tv': '#5E35B1',
  'film+tv/reviews': '#673AB7',
  'film+tv/news': '#7B1FA2',
  'fashion': '#E91E63',
  'environment': '#2E7D32',
  'nature': '#388E3C',
  'adult': '#880E4F',
  'piracy+illegal': '#B71C1C',
};

// Helper component to render category icon
export const CategoryIcon: React.FC<{ category: string; size?: number; color?: string }> = ({ 
  category, 
  size = 24, 
  color 
}) => {
  const IconComponent = categoryIconMap[category];
  const defaultColor = categoryColorMap[category] || 'currentColor';
  const iconColor = color || defaultColor;
  
  if (!IconComponent) {
    // Default fallback icon (document)
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color: iconColor }}>
        <path d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }
  
  return <IconComponent size={size} color={iconColor} />;
};
